import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Params } from '@angular/router';

import { GroupedKey } from '../../../interfaces/DisplayInterfaces';
import { DisplayStateService } from '../../../services/DisplayStateService';
import { NameValue } from '../../../interfaces/WidgetInterfaces';

declare const $: any;

@Component({
  selector: 'app-recursive-panel',
  template: `<div class="leaf" *ngIf="levelsBelow > 0; else lastLevel">
    <div class="leaf" *ngFor="let gc of GroupedKeyList | groupKeyFilter; let i = index">
        <a href="javascript:void(0)" (click)="gc.collapsed = !gc.collapsed">
            <i class='fa fa-chevron-right' [ngClass]="(gc.collapsed)?'fa-chevron-right':'fa-chevron-down'"></i>
        </a>
        <a [platformRouterLink]="getContext(gc.context)">{{gc.name}}</a>
        <div *ngIf="!gc.collapsed" class="collapse show" id="{{gc.key}}">
            <div class="leaf">
                <app-recursive-panel *ngIf="levelsBelow > 0" [additionalContext]="additionalContext" [GroupedKeyList]="gc.children" [levelsBelow]="levelsBelow-1" [toggleState]="toggleState" [topLevel]="false"></app-recursive-panel>
            </div>
        </div>
    </div>
</div>
<ng-template #lastLevel>
    <div class="leaf" *ngFor="let gc of GroupedKeyList | groupKeyFilter">
        <a [platformRouterLink]="getContext(gc.context)">{{gc.name}}</a>
        <span class="badge">{{gc.badge}}</span>
    </div>
</ng-template>`,
  styles: [`.leaf{
    padding:.25em 0 .25em .25em;
    width:100%;
}`]
})
export class RecursivePanelComponent implements OnInit {

  @Input() GroupedKeyList: GroupedKey[];
  @Input() levelsBelow: number;
  @Input() toggleState: string;
  @Input() additionalContext: NameValue = undefined;
  @Input() topLevel: boolean;

  constructor(public displayStateService: DisplayStateService, private myElement: ElementRef) { }

  getContext(ctxt: Params) {
    if (this.additionalContext !== null && this.additionalContext !== undefined) {
      ctxt[this.additionalContext.name] = this.additionalContext.value;
    }
    return ctxt;
  }

  ngOnInit() {
  }
}
